import React from 'react'
import PropTypes from 'prop-types'
import WarningIcon from '@material-ui/icons/Warning'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

export default function BootstrapAlert (props) {
  return (
    <div className={`alert alert-${props.class} no-icon`}>
      <div className="d-flex align-items-center">
        {['warning', 'danger'].includes(props.class)
          ? <WarningIcon className='mr-2'></WarningIcon>
          : <InfoOutlinedIcon className='mr-2'></InfoOutlinedIcon>
        }
        <div>
          {props.children}
        </div>
      </div>
    </div>
  )
}

BootstrapAlert.propTypes = {
  children: PropTypes.element,
  class: PropTypes.string
}
